module.exports = __webpack_public_path__ + "img/print.3ed32205.png";